import {
  useListPayors,
  useListProvidersBySite,
  useListRolesByOrganization,
} from 'api/resource';
import { useState, useEffect } from 'react';
import { useCurrentSiteStore } from 'store/SiteStore';

export const useAdminProviderManagementData = () => {
  const { id: siteID, organizationID } = useCurrentSiteStore();
  const [isLoading, setIsLoading] = useState(false);

  const providersResult = useListProvidersBySite({ siteID });
  const payorsResult = useListPayors();

  const rolesResult = useListRolesByOrganization({
    organizationID,
  });

  useEffect(() => {
    if (
      providersResult.isLoading ||
      payorsResult.isLoading ||
      rolesResult.isLoading
    ) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [
    providersResult.isLoading,
    payorsResult.isLoading,
    rolesResult.isLoading,
  ]);
  const isError = providersResult.isError || rolesResult.isError;
  const isFetching = providersResult.isFetching || rolesResult.isFetching;
  const errorMessage =
    providersResult.error?.message || rolesResult.error?.message;

  return {
    providers: providersResult.data || [],
    payors: payorsResult.data || [],
    allProviders: providersResult.data || [],
    roles: rolesResult.data || [],
    currentSite: useCurrentSiteStore.getState(),
    isLoading,
    isError,
    isFetching,
    errorMessage,
    refetchProviders: providersResult.refetch,
    setIsLoading,
  };
};
